import {Component, EventEmitter, Inject, Input, OnInit, Output, OnDestroy, ViewChild, ElementRef, Optional } from "@angular/core";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";
import {FormControl, FormGroup} from "@angular/forms";
import {ConfigStateService} from "../../../../../app/config/config-state.service";
import { ClientService, TaxReturnService } from "../../../../../../swaggerServices";
import { Subject } from "rxjs";
import { takeUntil } from "rxjs/operators";
declare const $: any;

@Component({
    selector: "remove-from-batch",
    templateUrl: "./remove-from-batch.component.html",
    styleUrls: ["./remove-from-batch.component.scss"],
    standalone: false
})
export class RemoveFromBatch implements OnInit, OnDestroy {
  @Input() selectedTaxReturns;
  @Input() currentBatchList;
  @Input() selectedBatchFilter;
  @Input() taxReturnAlias: string;
  @Output() completed = new EventEmitter();
  showModal = true;
  responseData = [];
  bulkActionState: "OPENED" | "LOADING" | "COMPLETED" = null;
  errorMessage = "";

  private unsubscribe: Subject<void> = new Subject();
  constructor(
              private taxReturnService: TaxReturnService,
              private clientService: ClientService,
              private config: ConfigStateService,
              @Optional() private dialogRef?: MatDialogRef<RemoveFromBatch>,
              @Optional() @Inject(MAT_DIALOG_DATA) data?: Partial<RemoveFromBatch>) {
    Object.assign(this, data);
  }

  get selectedTaxReturnIds() {
    return this.selectedTaxReturns ?  Object.keys(this.selectedTaxReturns).map(n=>Number(n)) : [];
  }

  get submitButtonDisabled() {
    return !this.selectedBatchFilter || this.bulkActionState==='LOADING'
  }

  ngOnInit() {
    this.bulkActionState = 'OPENED';
    this.errorMessage = '';
    if (!this.currentBatchList.length) {
      this.errorMessage = 'Client has no batch';
      return;
    }
    if (!this.selectedBatchFilter) {
      this.errorMessage = `You need to select a batch where you would like selected ${this.taxReturnAlias}s to be removed from`
    }
  }

  ngOnDestroy() {
    this.unsubscribe.next();
    this.unsubscribe.complete();
  }

  removeFromBatch() {
    this.errorMessage = '';
    this.bulkActionState = 'LOADING';
      this.clientService.removeTaxReturnsFromBatch({  batchId: this.selectedBatchFilter, taxReturnIds: this.selectedTaxReturnIds})
      .pipe(takeUntil(this.unsubscribe))
      .subscribe(resp => {
        this.bulkActionState = 'COMPLETED';
      }, error => {
        this.errorMessage = "Something went wrong, please check error message and try again.";
        this.bulkActionState = 'OPENED';
        return;
      });
  }

  onClose(result: boolean = false) {
    if (this.dialogRef) {
      this.dialogRef.close(result);
      return;
    }
    this.showModal = false;
    this.completed.emit();
  }

}
